module.exports = __webpack_public_path__ + "img/8.f58b4344.png";